// Libraries
import * as React from "react";
import { CSSTransition } from "react-transition-group";

// UITK
import { classNames } from "uitk-react-utils";

// Blossom Components
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { UitkPrimaryButton, UitkButtonSize } from "uitk-react-button";

interface StickyCTAMobileProps extends React.HTMLAttributes<HTMLDivElement> {
  isSticky: boolean;
  moduleName: string;
  submitButtonText: string;
  scrollTarget: React.RefObject<HTMLElement>;
}

const ButtonTracked = FlexClickTracker(UitkPrimaryButton);

/**
 * Sticky Call to Action button for the Wizard. When you click it brings focus to Wizard
 *
 * @param {boolean} isSticky - Determines if the Call to Action is visible or not
 * @param {string} moduleName - The module parent name
 * @param {string} submitButtonText - The button label text
 * @param {React.RefObject<HTMLElement>} scrollTarget - The reference to the target element that brings you into it
 */
export const StickyCTAMobile: React.FC<StickyCTAMobileProps> = ({
  moduleName,
  submitButtonText,
  className,
  isSticky,
  scrollTarget,
  ...htmlDivHTMLProps
}: StickyCTAMobileProps) => {
  function scrollTo() {
    const element =
      scrollTarget.current && scrollTarget.current && scrollTarget.current.parentElement;

    if (element) {
      element.scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
      element.focus();
    }
  }

  return (
    <CSSTransition
      in={isSticky}
      timeout={300}
      classNames="slide-in"
      mountOnEnter={true}
      unmountOnExit={true}
    >
      <div
        className={classNames("StickyCTAMobile all-x-padding-three all-y-padding-three", className)}
        {...htmlDivHTMLProps}
      >
        <ButtonTracked
          tag="button"
          rfrr={"hotel.wizard.cta"}
          linkName="Call to action click event in the wizard"
          moduleName={moduleName}
          className="wizard-cta-btn"
          text={submitButtonText}
          size={UitkButtonSize.SMALL}
          isFullWidth={true}
          data-testid="wizard-cta-button"
          onClick={scrollTo}
        />
      </div>
    </CSSTransition>
  );
};

StickyCTAMobile.displayName = "StickyCTAMobile";

export default StickyCTAMobile;
